<template>
  <div :class="$style.multiSiteComparisonReportContainer">
    <div v-if="comparisonAggregateCriteriaConfiguration.length > 0">
      <Card
        :class="[
          $style.individualCriteriaContainer,
          comparisonIndividualMixedCriteriaConfiguration.length === 0
            ? $style.removeBottomMarginIndividualCriteriaContainer
            : null,
        ]"
        v-if="analysisFilter.checkIndividualCriteria && dataSet.length > 0"
      >
        <div
          v-for="(dataSetValue, dataSetIndex) in dataSet"
          :key="dataSetIndex"
        >
          <div
            :class="[
              $style.individualChartTitle,
              dataSetIndex !== 0 ? $style.applyMarginTitle : null,
            ]"
            v-if="loadingSet[dataSetIndex] ? loadingSet[dataSetIndex] : false"
          >
            <CriteriaViewUpdateComponent
              :criteria="criteriaList[dataSetIndex]"
              :count="dataSetIndex + 1"
              :isProject="true"
            />
          </div>
          <div v-if="analysisFilter.selectedChartType === 'Vertical Bar Chart'">
            <VerticalBarChart
              v-if="loadingSet[dataSetIndex] ? loadingSet[dataSetIndex] : false"
              :class="$style.individualChart"
              :barChartData="dataSetValue"
              :barChartOptions="dataSetOptions[dataSetIndex]"
            ></VerticalBarChart>
          </div>
          <div v-else>
            <HorizontalBarChart
              v-if="loadingSet[dataSetIndex] ? loadingSet[dataSetIndex] : false"
              :class="$style.individualChartHorizontal"
              :barChartData="dataSetValue"
              :barChartOptions="dataSetOptions[dataSetIndex]"
            ></HorizontalBarChart>
          </div>
          <div :class="$style.individualCriteriaStatisticContainer">
            <h1 :class="$style.title">Table</h1>
            <div :class="$style.table">
              <MultiSiteComparisonTable
                :siteList="projectSitelist"
                :individualSiteMode="
                  analysisFilter.checkIndividualSite ? true : false
                "
                :comparisonPeriods="analysisFilter.comparisonPeriods"
                :filteredSites="analysisFilter.filteredSites"
                :source="
                  comparisonIndividualBooleanCriteriaConfiguration[dataSetIndex]
                "
                :showComplianceRate="
                  comparisonIndividualBooleanCriteriaConfiguration[
                    dataSetIndex
                  ][0].criteriaType === 'BOOLEAN'
                "
                :periodsInfo="periodsInfo"
              />
            </div>
          </div>
        </div>
      </Card>
      <div
        :class="$style.verticalChartContainer"
        v-if="
          !analysisFilter.checkIndividualCriteria &&
          dataSet.length > 0 &&
          analysisFilter.selectedChartType === 'Vertical Bar Chart'
        "
      >
        <VerticalBarChart
          :class="$style.aggregateCriteriasVerticalBarChart"
          v-if="loadingSet[0] ? loadingSet[0] : false"
          :barChartData="dataSet[0]"
          :barChartOptions="dataSetOptions[0]"
        />
        <div v-if="analysisFilter.filteredCriterias.length > 8">
          <table :class="$style.criteriaListTable">
            <tr
              v-for="(
                projectCriteria, projectCriteriaIndex
              ) in getSelectedCriteriaList"
              :key="projectCriteriaIndex"
            >
              <td>{{ projectCriteriaIndex + 1 + '.' }}</td>
              <td>{{ projectCriteria.title }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div
        :class="$style.horizontalChartContainer"
        v-if="
          !analysisFilter.checkIndividualCriteria &&
          dataSet.length > 0 &&
          analysisFilter.selectedChartType === 'Horizontal Bar Chart'
        "
      >
        <HorizontalBarChart
          v-if="loadingSet[0] ? loadingSet[0] : false"
          :class="$style.aggregateCriteriasHorizontalBarChart"
          :barChartData="dataSet[0]"
          :barChartOptions="dataSetOptions[0]"
        ></HorizontalBarChart>
        <div v-if="analysisFilter.filteredCriterias.length > 8">
          <table :class="$style.criteriaListTable">
            <tr
              v-for="(
                projectCriteria, projectCriteriaIndex
              ) in getSelectedCriteriaList"
              :key="projectCriteriaIndex"
            >
              <td>{{ projectCriteriaIndex + 1 + '.' }}</td>
              <td>{{ projectCriteria.title }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div
        :class="$style.statisticContainer"
        v-if="renderOverallStatisticTable"
      >
        <div v-if="!analysisFilter.checkIndividualCriteria">
          <h1 :class="$style.title">Table</h1>
          <div
            v-for="(record, index) in comparisonAggregateCriteriaConfiguration"
            :key="`static${index}`"
            :class="$style.item"
          >
            <h2>
              <CriteriaViewUpdateComponent
                :criteria="record[0]"
                :count="index + 1"
                :isProject="true"
              />
            </h2>
            <div :class="$style.table">
              <MultiSiteComparisonTable
                :siteList="projectSitelist"
                :individualSiteMode="
                  analysisFilter.checkIndividualSite ? true : false
                "
                :comparisonPeriods="analysisFilter.comparisonPeriods"
                :filteredSites="analysisFilter.filteredSites"
                :source="record"
                :showComplianceRate="record[0].criteriaType === 'BOOLEAN'"
                :periodsInfo="periodsInfo"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-for="(
              record, index
            ) in comparisonIndividualMixedCriteriaConfiguration"
            :key="`static${index}`"
            :class="$style.mixedItem"
          >
            <h2>
              {{ getMixedBooleanTitleIndex(index) }}. {{ record[0].title }}
            </h2>
            <h1 :class="$style.mixedTitle">Table</h1>
            <div :class="$style.table">
              <MultiSiteComparisonTable
                :siteList="projectSitelist"
                :individualSiteMode="
                  analysisFilter.checkIndividualSite ? true : false
                "
                :comparisonPeriods="analysisFilter.comparisonPeriods"
                :filteredSites="analysisFilter.filteredSites"
                :source="record"
                :showComplianceRate="record[0].criteriaType === 'BOOLEAN'"
                :periodsInfo="periodsInfo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep as _cloneDeep, get as _get, map as _map } from 'lodash';
import Card from '@/components/Card.vue';
import MultiSiteComparisonTable from '@/components/reports/MultiSiteComparisonTable.vue';
import VerticalBarChart from '@/components/reports/VerticalBarChart';
import HorizontalBarChart from '@/components/reports/HorizontalBarChart';
import {
  ChartType,
  ChartRecords,
  ProjectCriteria,
  ProjectSite,
  ProjectReportPeriod,
  ProjectReportSinglePeriodResponse,
  ProjectReportMultiplePeriodResponse,
} from '@/store/modules/projects/types/projects.types';
import { CRITERION_TYPE } from '@/store/types/criterions.types';
import {
  chartColorSet,
  primaryChartColor,
  labelSplitIndex,
} from '@/store/types/general.types';
import dayjs from 'dayjs';
import CriteriaViewUpdateComponent from './CriteriaViewUpdateComponent.vue';

const dirtyMonths: string[] = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({
  components: {
    Card,
    VerticalBarChart,
    HorizontalBarChart,
    MultiSiteComparisonTable,
    CriteriaViewUpdateComponent,
  },
})
export default class MultiSiteComparisonReport extends Vue {
  @Prop()
  public analysisFilter!: any;
  @Prop()
  public projectCriteriaList!: ProjectCriteria[];
  @Prop()
  public projectSitelist!: ProjectSite[];
  @Prop()
  public comparisonReportResponse!: ProjectReportMultiplePeriodResponse;

  public dataSet: any[] = [];
  public dataSetOptions: any[] = [];
  public loadingSet: boolean[] = [];
  public verticalBarChartDataSetOption: any = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 100,
            min: 0,
          },
          gridLines: {
            display: true,
          },
          scaleLabel: {
            labelString: 'Compliance %',
            display: true,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: true,
          },
          scaleLabel: {
            labelString: 'Criteria',
            display: false,
          },
          ticks: {
            minRotation: 0,
            callback: (label: string, index: number) => {
              return this.generateLabel(label, index);
            },
          },
        },
      ],
    },
    legend: {
      display: true,
      onHover: (e: any) => {
        e.target.style.cursor = 'pointer';
      },
      onLeave: (e: any) => {
        e.target.style.cursor = 'default';
      },
      labels: {
        boxWidth: 15,
      },
      align: 'start',
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          if (tooltipItem.yLabel < 0) {
            label += 'N/A';
          } else {
            label += Math.round(tooltipItem.yLabel * 100) / 100;
          }
          return label;
        },
      },
    },
  };
  public horizontalBarChartDataSetOption: any = {
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 100,
            min: 0,
          },
          gridLines: {
            display: true,
          },
          scaleLabel: {
            labelString: 'Compliance %',
            display: true,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: true,
          },
          scaleLabel: {
            labelString: 'Criteria',
            display: false,
          },
          ticks: {
            minRotation: 0,
            callback: (label: string, index: number) => {
              return this.generateLabel(label, index);
            },
          },
        },
      ],
    },
    legend: {
      display: true,
      onHover: (e: any) => {
        e.target.style.cursor = 'pointer';
      },
      onLeave: (e: any) => {
        e.target.style.cursor = 'default';
      },
      labels: {
        boxWidth: 15,
      },
      align: 'start',
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          if (tooltipItem.xLabel < 0) {
            label += 'N/A';
          } else {
            label += Math.round(tooltipItem.xLabel * 100) / 100;
          }
          return label;
        },
      },
    },
  };
  public comparisonIndividualBooleanCriteriaConfiguration: any[] = [];
  public comparisonIndividualMixedCriteriaConfiguration: any[] = [];
  public comparisonAggregateCriteriaConfiguration: any[] = [];
  public criteriaNames: string[] = [];
  public criteriaList: ProjectCriteria[] = [];
  public renderOverallStatisticTable: boolean = true;
  public periodsInfo: ProjectReportPeriod[] = [];

  public mounted() {
    this.populateData();
  }

  public populateData() {
    this.periodsInfo = _cloneDeep(this.analysisFilter.comparisonPeriods);
    const transformedComparisonPeriods: Date[][] = [];
    this.analysisFilter.comparisonPeriods.forEach((comparisonPeriod: any) => {
      const transformedSelectedPeriod: Date[] = [];
      transformedSelectedPeriod.push(new Date(comparisonPeriod.startedAt));
      if (comparisonPeriod.endedAt === null) {
        transformedSelectedPeriod.push(new Date(dayjs().endOf('day').format()));
      } else {
        transformedSelectedPeriod.push(new Date(comparisonPeriod.endedAt));
      }
      transformedComparisonPeriods.push(transformedSelectedPeriod);
    });
    this.analysisFilter.comparisonPeriods = _cloneDeep(
      transformedComparisonPeriods,
    );
    if (!this.comparisonReportResponse.success) {
      this.dataSet = [];
      this.dataSetOptions = [];
      this.loadingSet = [];
      this.comparisonIndividualBooleanCriteriaConfiguration = [];
      this.comparisonIndividualMixedCriteriaConfiguration = [];
    } else {
      this.dataSet = [];
      this.dataSetOptions = [];
      this.loadingSet = [];
      this.comparisonIndividualBooleanCriteriaConfiguration = [];
      this.comparisonIndividualMixedCriteriaConfiguration = [];
      const chartData: ChartRecords[][] = [];
      const statisticData: any[][] = [];
      const samplingConfigurationData: any[] = [];
      _map(
        this.comparisonReportResponse.comparisonResult,
        (comparisonResult: ProjectReportSinglePeriodResponse) => {
          const dirtyChartData = comparisonResult.chartData;
          const dirtyStatisticData =
            comparisonResult.statisticData.configurationData;
          if (dirtyChartData.length > 0) {
            chartData.push(dirtyChartData);
          }
          statisticData.push(dirtyStatisticData);
          samplingConfigurationData.push(
            comparisonResult.statisticData.samplingConfiguration,
          );
        },
      );
      this.generateComparisonConfigurationData(
        statisticData,
        samplingConfigurationData,
      );
      if (chartData.length > 0) {
        this.multiSiteComparisonRender(chartData);
      }
    }
  }

  public multiSiteComparisonRender(chartData: ChartRecords[][]) {
    if (this.analysisFilter.checkIndividualSite) {
      if (this.analysisFilter.checkIndividualCriteria) {
        this.renderComparisonIndividualSiteIndividualCriteria(chartData);
      } else {
        this.renderComparisonIndividualSiteAggregateCriteria(chartData);
      }
    } else {
      if (this.analysisFilter.checkIndividualCriteria) {
        this.renderComparisonAggregateSiteIndividualCriteria(chartData);
      } else {
        this.renderComparisonAgregateSiteAggregateCriteria(chartData);
      }
    }
  }

  public renderComparisonIndividualSiteIndividualCriteria(
    chartData: ChartRecords[][],
  ) {
    this.criteriaNames = [];
    const booleanFilteredCriteriaIds: number[] = this.getBooleanCriteriaIds;
    _map(booleanFilteredCriteriaIds, (criteriaId: number) => {
      let criteriaName = '';
      _map(this.projectCriteriaList, (projectCriteria) => {
        if (projectCriteria.id === criteriaId) {
          criteriaName = projectCriteria.title;
          this.criteriaNames.push(projectCriteria.title);
          this.criteriaList.push(projectCriteria);
        }
      });
      const data = {
        labels: [] as string[],
        datasets: [] as any[],
      };
      let dataOptions = {};
      let dataOptionsObject: any = {};
      Object.keys(chartData).forEach((key: string) => {
        const chartValues: number[] = [];
        const siteNames: string[] = [];
        const backgroundColors: string[] = [];
        const singleChartData = chartData[Number(key)];
        Object.keys(singleChartData).map((dataKey: string) => {
          if (
            singleChartData[Number(dataKey)].projectCriteriaId === criteriaId
          ) {
            _map(
              this.analysisFilter.filteredSites,
              (siteMapId: number, siteMapIndex: string) => {
                chartValues.push(
                  singleChartData[Number(dataKey)].data[Number(siteMapIndex)]
                    .compliance,
                );
              },
            );
            _map(singleChartData[Number(dataKey)].data, (eachRecord) => {
              siteNames.push(eachRecord.site.name);
              backgroundColors.push(chartColorSet[Number(key)]);
            });
          }
        });
        const dataSetObject = {
          label: this.formatDateRange(
            this.analysisFilter.comparisonPeriods[Number(key)],
          ),
          backgroundColor: backgroundColors,
          hoverBackgroundColor: backgroundColors,
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: '#249EBF',
          data: chartValues,
          categoryPercentage: this
            .getIndividualCriteriaIndividualSiteChartCategoryPercentage,
        };
        data.datasets.push(dataSetObject);
        data.labels = _cloneDeep(siteNames);
      });
      if (
        this.analysisFilter.selectedChartType === ChartType.verticalBarChart
      ) {
        dataOptionsObject = _cloneDeep(this.verticalBarChartDataSetOption);
      } else {
        dataOptionsObject = _cloneDeep(this.horizontalBarChartDataSetOption);
      }
      dataOptionsObject.tooltips.callbacks.title = () => criteriaName;
      dataOptionsObject.tooltips.callbacks.afterTitle = (item: any[]) =>
        item[0].label;
      dataOptions = _cloneDeep(dataOptionsObject);
      this.dataSet.push(data);
      this.dataSetOptions.push(dataOptions);
      this.loadingSet.push(true);
    });
  }

  public renderComparisonAggregateSiteIndividualCriteria(
    chartData: ChartRecords[][],
  ) {
    let siteName: string;
    switch (this.analysisFilter.filteredSites.length) {
      case 1:
        siteName = chartData[0][0].data[0].site.name;
        break;
      case this.projectSitelist.length:
        siteName = 'All Sites';
        break;
      default:
        siteName =
          'Selected sites (' + this.analysisFilter.filteredSites.length + ')';
    }
    this.criteriaNames = [];
    const booleanFilteredCriteriaIds: number[] = this.getBooleanCriteriaIds;
    _map(booleanFilteredCriteriaIds, (criteriaId: number) => {
      let criteriaName = '';
      _map(this.projectCriteriaList, (projectCriteria) => {
        if (projectCriteria.id === criteriaId) {
          criteriaName = projectCriteria.title;
          this.criteriaNames.push(projectCriteria.title);
          this.criteriaList.push(projectCriteria);
        }
      });
      const data = {
        labels: [] as string[],
        datasets: [] as any[],
      };
      let dataOptions = {};
      let dataOptionsObject: any = {};
      Object.keys(chartData).forEach((key: string) => {
        const chartValues: number[] = [];
        const backgroundColors: string[] = [];
        const singleChartData = chartData[Number(key)];
        Object.keys(singleChartData).map((dataKey: string) => {
          if (
            singleChartData[Number(dataKey)].projectCriteriaId === criteriaId
          ) {
            chartValues.push(
              singleChartData[Number(dataKey)].data[0].compliance,
            );
          }
        });
        backgroundColors.push(chartColorSet[Number(key)]);
        const dataSetObject = {
          label: this.formatDateRange(
            this.analysisFilter.comparisonPeriods[Number(key)],
          ),
          backgroundColor: backgroundColors,
          hoverBackgroundColor: backgroundColors,
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: '#249EBF',
          data: chartValues,
          categoryPercentage: this
            .getIndividualCriteriaAggregateSiteChartCategoryPercentage,
        };
        data.datasets.push(dataSetObject);
      });
      data.labels = [siteName];
      if (
        this.analysisFilter.selectedChartType === ChartType.verticalBarChart
      ) {
        dataOptionsObject = _cloneDeep(this.verticalBarChartDataSetOption);
      } else {
        dataOptionsObject = _cloneDeep(this.horizontalBarChartDataSetOption);
      }
      dataOptionsObject.tooltips.callbacks.title = () => criteriaName;
      dataOptionsObject.tooltips.callbacks.afterTitle = () => siteName;
      dataOptions = _cloneDeep(dataOptionsObject);
      this.dataSet.push(data);
      this.dataSetOptions.push(dataOptions);
      this.loadingSet.push(true);
    });
  }

  public getSiteNameByAuditSiteMapId(auditSiteMapId: number): string {
    const siteName = this.projectSitelist.filter(
      (auditSite) => auditSite.id === auditSiteMapId,
    );
    return siteName[0].site.name;
  }

  public getChartValues(chartData: any[], projectSiteMapId: number): number[] {
    const chartValues: number[] = [];
    Object.keys(chartData).map((key: string) => {
      const dirtyChartData = chartData[Number(key)];
      _map(dirtyChartData.data, (dirtyData, dirtyDataIndex) => {
        if (dirtyData.projectSiteId === projectSiteMapId) {
          chartValues.push(dirtyData.compliance);
        }
      });
    });
    return chartValues;
  }

  public getCriteriaNames(chartData: ChartRecords[]): string[] {
    const criteriaNames: string[] = [];
    Object.keys(chartData).map((key: string) => {
      criteriaNames.push(chartData[Number(key)].criteria.title);
    });
    return criteriaNames;
  }

  public getBackgroundColors(
    periodIndex: number,
    projectSiteMapIdIndex: number,
    totalPeriods: number,
  ): string[] {
    const backgroundColors: string[] = [];
    const dirtyColorSet = _cloneDeep(chartColorSet);
    const factor = projectSiteMapIdIndex * totalPeriods;
    if (factor !== 0) {
      dirtyColorSet.splice(0, factor);
    }
    _map(
      this.analysisFilter.filteredCriterias,
      (auditCriteriaMapId: number, auditCriteriaMapIndex: string) => {
        backgroundColors.push(dirtyColorSet[periodIndex]);
      },
    );
    return backgroundColors;
  }

  public getSiteName(auditSiteMapId: number): string {
    const auditSite = this.projectSitelist.filter(
      (site) => site.id === auditSiteMapId,
    );
    return auditSite[0].site.name;
  }

  public getCustomLabel(auditSiteMapId: number, periodKey: number): string {
    const siteName = this.getSiteName(auditSiteMapId);
    const formatPeriod = this.formatDateRange(
      this.analysisFilter.comparisonPeriods[periodKey],
    );
    return siteName + ' ( ' + formatPeriod + ' ) ';
  }

  public renderComparisonIndividualSiteAggregateCriteria(
    chartData: ChartRecords[][],
  ) {
    const data = {
      labels: [] as string[],
      datasets: [] as any[],
    };
    let dataOptions = {};
    _map(
      this.analysisFilter.filteredSites,
      (projectSiteMapId: number, projectSiteMapIdIndex: string) => {
        Object.keys(chartData).map((key: string) => {
          const singleChartData = chartData[Number(key)];
          const chartValues: number[] = this.getChartValues(
            singleChartData,
            projectSiteMapId,
          );
          const backgroundColors: string[] = this.getBackgroundColors(
            Number(key),
            Number(projectSiteMapIdIndex),
            this.analysisFilter.comparisonPeriods.length,
          );
          const dataSetObject = {
            label: this.getCustomLabel(projectSiteMapId, Number(key)),
            backgroundColor: backgroundColors,
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#249EBF',
            data: chartValues,
            categoryPercentage: this
              .getAggregateCriteriaAggregateSiteChartCategoryPercentage,
          };
          data.datasets.push(dataSetObject);
        });
      },
    );
    let dataOptionsObject;
    if (this.analysisFilter.selectedChartType === ChartType.verticalBarChart) {
      dataOptionsObject = _cloneDeep(this.verticalBarChartDataSetOption);
    } else {
      dataOptionsObject = _cloneDeep(this.horizontalBarChartDataSetOption);
    }
    data.labels = this.getCriteriaNames(chartData[0]);
    dataOptions = _cloneDeep(dataOptionsObject);
    this.dataSet.push(data);
    this.dataSetOptions.push(dataOptions);
    this.loadingSet.push(true);
  }

  public renderComparisonAgregateSiteAggregateCriteria(
    chartData: ChartRecords[][],
  ) {
    let siteName: string;
    switch (this.analysisFilter.filteredSites.length) {
      case 1:
        siteName = chartData[0][0].data[0].site.name;
        break;
      case this.projectSitelist.length:
        siteName = 'All Sites';
        break;
      default:
        siteName =
          'Selected sites (' + this.analysisFilter.filteredSites.length + ')';
    }
    const data = {
      labels: [] as string[],
      datasets: [] as any[],
    };
    let dataOptions = {};
    const labels: string[] = [];
    let dataOptionsObject: any = {};
    Object.keys(chartData).map((key: string) => {
      const chartValues: number[] = [];
      const backgroundColors: string[] = [];
      const singleChartData = chartData[Number(key)];
      Object.keys(singleChartData).map((dataKey: string) => {
        if (Number(key) === 0) {
          labels.push(singleChartData[Number(dataKey)].criteria.title);
        }
        chartValues.push(singleChartData[Number(dataKey)].data[0].compliance);
        backgroundColors.push(chartColorSet[Number(key)]);
      });
      const dataSetObject = {
        label: this.formatDateRange(
          this.analysisFilter.comparisonPeriods[Number(key)],
        ),
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors,
        pointBackgroundColor: 'white',
        borderWidth: 1,
        pointBorderColor: '#249EBF',
        data: chartValues,
        categoryPercentage: this
          .getAggregateCriteriaAggregateSiteChartCategoryPercentage,
      };
      data.datasets.push(dataSetObject);
    });
    if (this.analysisFilter.selectedChartType === ChartType.verticalBarChart) {
      dataOptionsObject = _cloneDeep(this.verticalBarChartDataSetOption);
    } else {
      dataOptionsObject = _cloneDeep(this.horizontalBarChartDataSetOption);
    }
    dataOptionsObject.tooltips.callbacks.afterTitle = () => siteName;
    data.labels = _cloneDeep(labels);
    dataOptions = _cloneDeep(dataOptionsObject);
    this.dataSet.push(data);
    this.dataSetOptions.push(dataOptions);
    this.loadingSet.push(true);
  }

  public generateComparisonConfigurationData(
    configurationData: any[],
    samplingConfigurationData: any[],
  ) {
    if (this.analysisFilter.checkIndividualSite) {
      if (
        Array.isArray(configurationData) &&
        configurationData.length ===
          this.analysisFilter.comparisonPeriods.length
      ) {
        const aggregateConfiguration: any[] = [];
        _map(this.analysisFilter.filteredCriterias, (criteriaId) => {
          const aggregateCriteriaConfiguration: any[] = [];
          _map(configurationData, (configData, index) => {
            let dirtyAggregateConfiguration: any = {};
            configData.forEach((data: any) => {
              if (data.projectCriteria.id === criteriaId) {
                let criteriaSamplingData = [];
                if (Array.isArray(data.criteriaSamplingData)) {
                  criteriaSamplingData = data.criteriaSamplingData.filter(
                    (item: any) => {
                      const criteriaOptionsDataDistribution =
                        item.criteriaOptionsDataDistribution;
                      const dirtyCriteriaSamplingData = Object.keys(
                        criteriaOptionsDataDistribution,
                      ).map((key: string) => ({
                        [key]:
                          data.criteriaSamplingData[0]
                            .criteriaOptionsDataDistribution[key],
                      }));
                      return dirtyCriteriaSamplingData;
                    },
                  );
                } else {
                  criteriaSamplingData.push({
                    ...data.criteriaSamplingData,
                  });
                }

                const dirtyConfig = {
                  id: data.projectCriteria.id,
                  title: _get(data, 'projectCriteria.title', ''),
                  criteriaType: _get(data, 'projectCriteria.criteriaType', ''),
                  sampleSize: Number(
                    _get(
                      data,
                      'criteriaSamplingDataConfigurations.sampleSize',
                      0,
                    ),
                  ),
                  criteriaOptions: JSON.parse(
                    data.projectCriteria.criteriaOptions,
                  ),
                  siteSamplingConfiguration:
                    data.siteSamplingDataConfigurations,
                  criteriaSamplingDataConfiguration:
                    data.criteriaSamplingDataConfigurations,
                  samplingConfiguration: samplingConfigurationData[index],
                  criteriaSamplingData,
                  isAuditCriteria: _get(data, 'isAuditCriteria', false),
                };
                dirtyAggregateConfiguration = _cloneDeep(dirtyConfig);
              }
            });
            aggregateCriteriaConfiguration.push(dirtyAggregateConfiguration);
          });
          aggregateConfiguration.push(aggregateCriteriaConfiguration);
        });
        this.comparisonAggregateCriteriaConfiguration = _cloneDeep(
          aggregateConfiguration,
        );
      } else {
        this.comparisonAggregateCriteriaConfiguration = [];
      }
    } else {
      if (
        Array.isArray(configurationData) &&
        configurationData.length ===
          this.analysisFilter.comparisonPeriods.length
      ) {
        const aggregateConfiguration: any[] = [];
        _map(this.analysisFilter.filteredCriterias, (criteriaId) => {
          const aggregateCriteriaConfiguration: any[] = [];
          _map(configurationData, (configData, index) => {
            let dirtyAggregateConfiguration: any = {};
            configData.forEach((data: any) => {
              if (data.projectCriteria.id === criteriaId) {
                const criteriaOptionsDataDistribution =
                  data.criteriaSamplingData.criteriaOptionsDataDistribution;
                const criteriaSamplingData = Object.keys(
                  criteriaOptionsDataDistribution,
                ).map((key: string) => ({
                  [key]:
                    data.criteriaSamplingData.criteriaOptionsDataDistribution[
                      key
                    ],
                }));
                const dirtyConfig = {
                  id: data.projectCriteria.id,
                  title: _get(data, 'projectCriteria.title', ''),
                  criteriaType: _get(data, 'projectCriteria.criteriaType', ''),
                  sampleSize: Number(
                    _get(
                      data,
                      'criteriaSamplingDataConfigurations.sampleSize',
                      0,
                    ),
                  ),
                  criteriaOptions: JSON.parse(
                    data.projectCriteria.criteriaOptions,
                  ),
                  siteSamplingConfiguration:
                    data.siteSamplingDataConfigurations,
                  criteriaSamplingDataConfiguration:
                    data.criteriaSamplingDataConfigurations,
                  samplingConfiguration: samplingConfigurationData[index],
                  criteriaSamplingData,
                  isAuditCriteria: _get(data, 'isAuditCriteria', false),
                };
                dirtyAggregateConfiguration = _cloneDeep(dirtyConfig);
              }
            });
            aggregateCriteriaConfiguration.push(dirtyAggregateConfiguration);
          });
          aggregateConfiguration.push(aggregateCriteriaConfiguration);
        });
        this.comparisonAggregateCriteriaConfiguration = _cloneDeep(
          aggregateConfiguration,
        );
      } else {
        this.comparisonAggregateCriteriaConfiguration = [];
      }
    }
    this.generateComparisonIndividualCriteriaSet(
      this.comparisonAggregateCriteriaConfiguration,
    );
  }

  public generateComparisonIndividualCriteriaSet(
    comparisonAggregateCriteriaConfiguration: any[],
  ) {
    this.comparisonIndividualBooleanCriteriaConfiguration = comparisonAggregateCriteriaConfiguration.filter(
      (item) => {
        return item[0].criteriaType === CRITERION_TYPE.BOOLEAN;
      },
    );
    this.comparisonIndividualMixedCriteriaConfiguration = comparisonAggregateCriteriaConfiguration.filter(
      (item) => {
        return item[0].criteriaType !== CRITERION_TYPE.BOOLEAN;
      },
    );
    if (
      this.comparisonIndividualBooleanCriteriaConfiguration.length ===
        this.comparisonAggregateCriteriaConfiguration.length &&
      this.analysisFilter.checkIndividualCriteria
    ) {
      this.renderOverallStatisticTable = false;
    }
  }

  public getDate(newValue: Date): string {
    return (
      newValue.getDate() +
      ' ' +
      dirtyMonths[newValue.getMonth()] +
      ' ' +
      newValue.getFullYear()
    );
  }

  public formatDateRange(date: Date[]): string {
    return this.getDate(date[0]) + ' - ' + this.getDate(date[1]);
  }

  public getMixedBooleanTitleIndex(index: number): number {
    return (
      this.comparisonIndividualBooleanCriteriaConfiguration.length + index + 1
    );
  }

  public generateLabel(label: string, index: number): string | string[] {
    if (this.analysisFilter.checkIndividualCriteria) {
      return this.transformLabel(label);
    } else {
      if (this.analysisFilter.filteredCriterias.length > 8) {
        return index + 1 + '.';
      }
      return this.transformLabel(label);
    }
  }

  public transformLabel(label: string): string | string[] {
    const words = label.split(' ');
    let endIndex: number = labelSplitIndex;
    let eachLine: string = '';
    const eachLabel: string[] = [];
    _map(words, (word: string, wordIndex: string) => {
      switch (Number(wordIndex)) {
        case 0:
          eachLine = word;
          break;
        case endIndex:
          eachLabel.push(eachLine);
          eachLine = word;
          endIndex += labelSplitIndex;
          break;
        case words.length - 1:
          eachLine += ' ' + word;
          eachLabel.push(eachLine);
          break;
        default:
          eachLine += ' ' + word;
      }
    });
    if (eachLabel.length >= 3) {
      eachLabel[2] = eachLabel[2] + '...';
      return eachLabel.slice(0, 3);
    }
    return label;
  }

  get getBooleanCriteriaIds(): number[] {
    const criteriaIds: number[] = [];
    const booleanCriteriaIds: number[] = [];
    _map(this.projectCriteriaList, (projectCriteria: ProjectCriteria) => {
      if (projectCriteria.criteriaType === CRITERION_TYPE.BOOLEAN) {
        booleanCriteriaIds.push(projectCriteria.id);
      }
    });
    _map(booleanCriteriaIds, (eachId: number) => {
      if (this.analysisFilter.filteredCriterias.includes(eachId)) {
        criteriaIds.push(eachId);
      }
    });
    return criteriaIds;
  }

  get getIndividualCriteriaAggregateSiteChartCategoryPercentage(): number {
    const noOfPeriods: number = this.analysisFilter.comparisonPeriods.length;
    return noOfPeriods <= 10 ? noOfPeriods * 0.1 : 0.8;
  }

  get getSingleCriteriaIndividualSiteChartCategoryPercentage(): number {
    const noOfPeriods: number = this.analysisFilter.comparisonPeriods.length;
    const noOfSites: number = this.analysisFilter.filteredSites.length;
    return noOfSites * noOfPeriods <= 10 ? noOfPeriods * 0.2 : 0.8;
  }

  get getAggregateCriteriaAggregateSiteChartCategoryPercentage(): number {
    const noOfBooleanCriterias: number = this
      .comparisonIndividualBooleanCriteriaConfiguration.length;
    if (noOfBooleanCriterias === 1) {
      return this.getIndividualCriteriaAggregateSiteChartCategoryPercentage;
    }
    const noOfPeriods: number = this.analysisFilter.comparisonPeriods.length;
    return noOfBooleanCriterias * noOfPeriods <= 10 ? noOfPeriods * 0.2 : 0.8;
  }

  get getIndividualCriteriaIndividualSiteChartCategoryPercentage(): number {
    const noOfBooleanCriterias: number = this
      .comparisonIndividualBooleanCriteriaConfiguration.length;
    if (noOfBooleanCriterias === 1) {
      return this.getSingleCriteriaIndividualSiteChartCategoryPercentage;
    }
    const noOfPeriods: number = this.analysisFilter.comparisonPeriods.length;
    if (this.analysisFilter.selectedChartType === ChartType.verticalBarChart) {
      return noOfBooleanCriterias * noOfPeriods <= 10 ? noOfPeriods * 0.2 : 0.8;
    } else {
      return noOfBooleanCriterias * noOfPeriods <= 10 ? noOfPeriods * 0.3 : 0.8;
    }
  }

  get getSelectedCriteriaList(): ProjectCriteria[] {
    const selectedCriteriaList: any[] = [];
    this.analysisFilter.filteredCriterias.forEach(
      (projectCriteriaMapId: number) => {
        const projectCriteria = this.projectCriteriaList.find((criteria) => {
          return (
            criteria.id === projectCriteriaMapId &&
            criteria.criteriaType === CRITERION_TYPE.BOOLEAN
          );
        });
        if (projectCriteria) {
          selectedCriteriaList.push(projectCriteria);
        }
      },
    );
    return selectedCriteriaList;
  }
}
</script>
<style lang="scss" module>
.verticalChartContainer,
.horizontalChartContainer {
  width: auto;
  height: auto;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 40px;
}
.statisticContainer {
  padding: 24px 24px 40px 24px;
  flex-direction: column;
  background-color: #fbfbfb;
  border: 1px solid #dfdfdf;
  .title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    color: #444f51;
  }
  .item {
    padding: 20px 0px 40px 0px;
    border-bottom: 1px solid $grey-2;
    .table {
      padding: 20px 0px 0px 20px;
    }
  }
  .item:last-child {
    padding-bottom: unset;
    border-bottom: unset;
  }
  .mixedItem {
    padding: 20px 0px 40px 0px;
    border-bottom: 1px solid $grey-2;
    &:first-child {
      padding-top: 0px;
    }
    .table {
      padding: 20px 0px 0px 0px;
    }
    .mixedTitle {
      margin-top: 24px;
      font-size: 14px;
      font-weight: bold;
      color: #444f51;
      text-transform: uppercase;
    }
  }
  .mixedItem:last-child {
    padding-bottom: unset;
    border-bottom: unset;
  }
}
.singleHorizontalchart {
  width: auto;
  height: auto;
  margin-top: 24px;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.multiSiteComparisonReportContainer {
  width: 100%;
}
.individualCriteriaContainer {
  display: flex;
  flex-direction: column;
  padding: unset;
  background-color: unset;
  border: unset;
  margin-bottom: 40px;
  box-shadow: unset;
}
.removeBottomMarginIndividualCriteriaContainer {
  margin-bottom: unset;
}
.individualChartTitle {
  color: #444f51;
  font-size: 16px;
  padding-left: 24px;
  padding-right: 24px;
}
.applyMarginTitle {
  margin-top: 60px;
}
.individualChart {
  padding: 24px 24px 0px 24px;
  margin-bottom: 24px;
  width: auto;
  height: auto;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.individualChartHorizontal {
  padding: 24px 24px 0px 24px;
  margin-bottom: 24px;
  width: auto;
  height: auto;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.individualCriteriaStatisticContainer {
  padding: 24px 24px 40px 24px;
  flex-direction: column;
  background-color: #fbfbfb;
  border: 1px solid #dfdfdf;
  .title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    color: #444f51;
  }
  .table {
    margin-top: 18px;
  }
  .item {
    padding: 20px 0;
    border-bottom: 1px solid $grey-2;
    .table {
      padding: 20px 0px 0px 20px;
    }
  }
  .item:last-child {
    padding-bottom: unset;
    border-bottom: unset;
  }
}
.aggregateCriteriasHorizontalBarChart {
  height: 800px;
  width: auto;
  margin-top: unset;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.aggregateCriteriasVerticalBarChart {
  height: auto;
  margin-top: unset;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.criteriaListTable {
  background: #eff7ff;
  width: 100%;
  margin-top: 20px;
  font-size: 12px;
  tr {
    td:first-child {
      text-align: right;
      width: 30px;
    }
    td:nth-child(2) {
      padding-left: 4px;
    }
  }
  td {
    padding-top: 2px;
    padding-bottom: 2px;
  }
  tr:first-child {
    td {
      padding-top: 12px;
    }
  }
  tr:last-child {
    td {
      padding-bottom: 12px;
    }
  }
}
</style>
